module.exports = __webpack_public_path__ + "img/linqapp.c4eaac6f.png";